// ??? Filter ??????????????????????????????????????????????????????????????????
export interface IFilterConfig {
    name: string;
    displayName: string;
    filterType: 'boolean' | 'text' | 'number' | 'date' | 'dateRange' | 'dropdown';
    dataType?: 'string' | 'number' | 'boolean' | 'date';
    options?: IFilterOption[];
    placeholder?: string;
}

export interface IFilterOption {
    label: string;
    value: any;
}

export interface IFilterRule {
    id: string;
    columnName: string;
    displayName: string;
    filterType: 'boolean' | 'text' | 'number' | 'date' | 'dateRange' | 'dropdown';
    operator?: 'equals' | 'contains' | 'startsWith' | 'endsWith' | 'greaterThan' | 'lessThan' | 'between';
    value?: any;
    dateFrom?: Date | null;
    dateTo?: Date | null;
    enabled: boolean;
}

// ??? Sort modal ???????????????????????????????????????????????????????????????
export interface ColumnOption {
    name: string;
    displayName: string;
    sortable: boolean;
    filterable?: boolean;
    filterType?: 'boolean' | 'text' | 'number' | 'date' | 'dateRange' | 'dropdown';
    options?: { label: string; value: any }[];
}

export interface SearchSortConfig {
    searchTerm: string;
    caseSensitive: boolean;
    exactMatch: boolean;
    searchFields: string[];
    sortRules: any[];
    filterRules: IFilterRule[];
}

// ??? Table ????????????????????????????????????????????????????????????????????
export interface ISubTableSelectedObject {
    type: string;
    data: any;
    entityName: string;
}

// ??? Document viewer ??????????????????????????????????????????????????????????
export interface DocumentDialogData {
    fileUrl: string;
    fileName: string;
    fileType?: string;
}

export interface IFilterSortList
{
    name: string;
    displayName: string;
    sortable: boolean;
    filterable?: boolean;
    filterType?: 'boolean' | 'text' | 'number' | 'date' | 'dateRange' | 'dropdown';
}
 
export interface ITableSelectedObject extends ISubTableSelectedObject
{
 
}
 
export interface IHeader
{
    headerName: string;
    entityName: string;
    type: string;
    css: string;
    filterable?: boolean;
    filterType?: 'boolean' | 'text' | 'number' | 'date' | 'dateRange' | 'dropdown';
    configKey?: string;   // key into config data to load dropdown options e.g. 'accountManager'
    labelKey?: string;    // property on each config item to use as label  (default: 'name')
    valueKey?: string;    // property on each config item to use as value  (default: 'id')
}

// Re-export search-sort models to avoid conflicts
export * from './search-sort.models';
